import React, { useState, useEffect } from "react";
import axios from "axios";
import {
  Box,
  Heading,
  Text,
  Image,
  VStack,
  Stack,
  useBreakpointValue,
  HStack,
  SimpleGrid,
  Icon,
  useColorModeValue,
  Container,
  // Divider,
} from "@chakra-ui/react";
import { motion } from "framer-motion";
import {
  FaAward,
  FaUsers,
  FaLightbulb,
  FaHandshake,
  FaCheckCircle,
} from "react-icons/fa";
import { FiGlobe, FiHeart, FiShield } from "react-icons/fi";
// import Profile from "../../../assets/images/Profile.png";
import Header from "../header/Header";
import { useHomeHook } from "../home/useHomeHook";
// import glass1 from "../../../assets/images/glass1.jpg";
// import glass2 from "../../../assets/images/glass2.jpg";
// import glass3 from "../../../assets/images/glass3.jpg";
// import glass4 from "../../../assets/images/glass4.jpg";
// import glass5 from "../../../assets/images/glass5.jpg";
// import glass6 from "../../../assets/images/glass6.jpg";
import {
  // useParams, Link,
  useNavigate,
} from "react-router-dom";
import Footer from "../footer/Footer";
import * as Constants from "../../../constants/Constants";

const MotionBox = motion(Box);

const Feature = ({ icon, title, text }) => {
  return (
    <MotionBox
      initial={{ opacity: 0, y: 20 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true }}
      transition={{ duration: 0.5, ease: "easeOut" }}
      p={8}
      bg={useColorModeValue("white", "#000000")}
      borderRadius="xl"
      boxShadow="lg"
      borderWidth="1px"
      borderColor={useColorModeValue("#000000", "#000000")}
      textAlign="center"
      h="100%"
      _hover={{
        transform: "translateY(-5px)",
        boxShadow: "xl",
        borderColor: useColorModeValue("#ffffffff", "#000000ff"),
      }}
      // transition="all 0.3s ease"
    >
      <Box
        display="inline-flex"
        p={3}
        borderRadius="full"
        bg="black"
        opacity={0.5}
        // bgGradient="linear(to-br, #87CEEB, purple.500)"
        color="white"
        mb={4}
      >
        <Icon as={icon} w={6} h={6} />
      </Box>
      <Heading
        size="md"
        mb={3}
        color={"black"}
      >
        {title}
      </Heading>
      <Text color={useColorModeValue("#000000", "#000000")}>{text}</Text>
    </MotionBox>
  );
};

const ValueCard = ({ icon, title, description }) => {
  return (
    <MotionBox
      initial={{ opacity: 0, y: 20 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true }}
      transition={{ duration: 0.5 }}
      p={6}
      bg={useColorModeValue("white", "#000000")}
      borderRadius="lg"
      boxShadow="md"
      textAlign="center"
      borderBottom="4px solid"
      borderColor="white"
    >
      <Icon as={icon} w={8} h={8} color="black" opacity={0.3} mb={4} />
      <Heading size="md" mb={3} color={useColorModeValue("#000000", "white")}>
        {title}
      </Heading>
      <Text color={useColorModeValue("#000000", "#000000")}>
        {description}
      </Text>
    </MotionBox>
  );
};

const About = (props) => {
  const navigate = useNavigate();
  const textAlign = useBreakpointValue({ base: "center", md: "left" });
  // const headingSize = useBreakpointValue({ base: 'xl', md: '2xl' });
  const textSize = useBreakpointValue({ base: "md", md: "lg" });
  const [images, setImages] = useState([]);
  // const mainGradient = useColorModeValue(
  //   'linear(to-r, #87CEEB, purple.50)',
  //   'linear(to-r, #000000, #000000)'
  // );
console.log(images)
  const [handleMenuEnter, handleMenuLeave, menuVisible, setHoveredItem] =
    useHomeHook(props);

  useEffect(() => {
    axios
      .get(Constants.REACT_APP_API_URL + "api/upload/about")
      .then((res) => {
        if (res.data.success) {
          setImages(res.data.data);
        }
      })
      .catch((err) => console.log(err));
  }, []);

  return (
    <Box bg={useColorModeValue("#FFFFFF", "#FFFFFF")}>
      <Header
        handleMenuEnter={handleMenuEnter}
        handleMenuLeave={handleMenuLeave}
        menuVisible={menuVisible}
        setHoveredItem={setHoveredItem}
        productImages={{
          "Sliding Partitions": images[1]?.image_url,
          "Swing Partitions": images[2]?.image_url,
          // "Flush Doors": glass3,
          "Bathroom & Wardrobes": images[3]?.image_url,
          "Shower Enclosures": images[4]?.image_url,
          "Led Mirrors": images[5]?.image_url,
        }}
        collections={[
          { name: "Sliding Partitions", path: "/product/1" },
          { name: "Swing Partitions", path: "/product/2" },
          // { name: "Flush Doors", path: "/product/3" },
          { name: "Bathroom & Wardrobes", path: "/product/4" },
          { name: "Shower Enclosures", path: "/product/5" },
          { name: "Led Mirrors", path: "/product/6" },
        ]}
      />

      {/* Hero Section */}
      <Container maxW="container.xl" py={{ md: 20 }} px={{ base: 6, md: 8 }} >
        <Stack
          direction={{ base: "column", lg: "row" }}
          spacing={{ md: 12 }}
          align="center"
          justify="space-between"
        >
          <VStack
            align={textAlign}
            spacing={6}
            flex="1"
            maxW={{ base: "100%", lg: "50%" }}
            mt={{ base: "7rem", md: "0", lg: "0" }}
          >
            <MotionBox
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.5 }}
            >
              <Text fontSize="lg" color="black.500" fontWeight="semibold" mb={2}>
                ABOUT ENSO
              </Text>
              <Heading
                as="h1"
                size="2xl"
                // bgGradient="linear(to-r, #87CEEB, #800080)"
                // bgClip="text"
                color={"black"}
                lineHeight="shorter"
                mb={4}
              >
                Crafting Elegant Spaces With Precision Glass Solutions
              </Heading>
              <Text
                fontSize="xl"
                color={useColorModeValue("#000000", "#000000")}
                lineHeight="tall"
                fontWeight="medium"
                mb={6}
              >
                Transforming spaces with innovative glass solutions since 2024.
                We combine artistry with functionality to create stunning
                environments that inspire and endure.
              </Text>
              <HStack
                spacing={4}
                justify={textAlign === "center" ? "center" : "flex-start"}
              >
                <Box
                  w="40px"
                  h="4px"
                  bgGradient="linear(to-r, white, black)"
                  borderRadius="full"
                />
                <Text fontSize="sm" color="#000000">
                  INNOVATION IN GLASS
                </Text>
              </HStack>
            </MotionBox>
          </VStack>
          
          <MotionBox
            flex="1"
            initial={{ opacity: 0, scale: 0.95 }}
            animate={{ opacity: 1, scale: 1 }}
            transition={{ duration: 0.5 }}
            position="relative"
            maxW={{ base: "100%", md: "500px" }}
            marginBottom="5rem"
          >
            {/* <Image
              src={Profile}
              alt="Company Overview"
              borderRadius="2xl"
              w="full"
              marginTop={{ base: "0.5rem", md: "3.5rem" }}
              objectFit="cover"
              shadow="xl"
              position="relative"
              zIndex={1}
            /> */}
            {/* {images.map((img, index) => {
            return( */}
                <Box >
              <Image
                src={images[0]?.image_url}
                alt="Company Overview"
              borderRadius="2xl"
              w="full"
              marginTop={{ base: "0.5rem", md: "3.5rem" }}
              objectFit="cover"
              shadow="xl"
              position="relative"
              zIndex={1}
              />
            </Box>
            {/* )
          })} */}
          </MotionBox>
        </Stack>
      </Container>

      {/* Features Section */}
      <Box py={16} bg={useColorModeValue("white", "#000000")}>
        <Container maxW="container.xl" px={{ base: 6, md: 8 }}>
          <VStack textAlign="center" mb={10}>
            <Text
              fontSize="sm"
              fontWeight="semibold"
              color="black"
              letterSpacing="wide"
            >
              WHY CHOOSE ENSO
            </Text>
            <Heading size="xl" maxW="2xl">
              Excellence in Every Detail
            </Heading>
            {/* <Divider w="80px" borderWidth="2px" borderColor="#87CEEB" /> */}
          </VStack>

          <SimpleGrid columns={{ base: 1, md: 2, lg: 4 }} spacing={8}>
            <Feature
              icon={FaAward}
              title="Premium Quality"
              text="Exceptional craftsmanship and materials in every project we undertake"
            />
            <Feature
              icon={FaUsers}
              title="Expert Team"
              text="Skilled professionals with decades of combined experience"
            />
            <Feature
              icon={FaLightbulb}
              title="Innovative Design"
              text="Cutting-edge solutions that push boundaries of glass applications"
            />
            <Feature
              icon={FaHandshake}
              title="Client Focused"
              text="Personalized service tailored to your specific needs and vision"
            />
          </SimpleGrid>
        </Container>
      </Box>

      {/* Mission & Vision Section */}
      <Box py={16} bg={useColorModeValue("#FFFFFF", "#FFFFFF")}>
        <Container maxW="container.xl" px={{ base: 6, md: 8 }}>
          <SimpleGrid columns={{ base: 1, md: 2 }} spacing={12}>
            <MotionBox
              initial={{ opacity: 0, x: -30 }}
              whileInView={{ opacity: 1, x: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.6 }}
              p={10}
              bg={useColorModeValue("white", "#000000")}
              borderRadius="xl"
              boxShadow="lg"
              borderTop="4px solid"
              borderColor="white"
            >
              <VStack spacing={6} align="start">
                <Box>
                  <Text
                    fontSize="sm"
                    fontWeight="semibold"
                    color="black"
                    mb={2}
                  >
                    OUR MISSION
                  </Text>
                  <Heading
                    as="h2"
                    size="xl"
                    mb={6}
                    color={useColorModeValue("#000000", "white")}
                  >
                    Redefining Spaces
                  </Heading>
                </Box>

                {[
                  "To revolutionize living and working spaces through innovative glass solutions",
                  "To combine aesthetics with functionality for practical elegance",
                  "To build lasting relationships based on trust and exceptional service",
                ].map((text, index) => (
                  <HStack key={index} spacing={4} align="flex-start">
                    <Icon
                      as={FaCheckCircle}
                      color="black"
                      opacity={0.7}
                      w={5}
                      h={5}
                      mt={1}
                    />
                    <Text
                      fontSize={textSize}
                      // color={useColorModeValue('#000000', '#000000')}
                    >
                      {text}
                    </Text>
                  </HStack>
                ))}
              </VStack>
            </MotionBox>

            <MotionBox
              initial={{ opacity: 0, x: 30 }}
              whileInView={{ opacity: 1, x: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.6 }}
              p={10}
              bg={useColorModeValue("white", "#000000")}
              borderRadius="xl"
              boxShadow="lg"
              borderTop="4px solid"
              borderColor="white"
            >
              <VStack spacing={6} align="start">
                <Box>
                  <Text
                    fontSize="sm"
                    fontWeight="semibold"
                    color="black"
                    mb={2}
                  >
                    OUR VISION
                  </Text>
                  <Heading
                    as="h2"
                    size="xl"
                    mb={6}
                    color={useColorModeValue("#000000", "white")}
                  >
                    Shaping the Future
                  </Heading>
                </Box>

                {[
                  "To be the industry leader in innovative glass applications",
                  "To inspire the creation of beautiful, functional spaces worldwide",
                  "To foster a culture of creativity and environmental responsibility",
                ].map((text, index) => (
                  <HStack key={index} spacing={4} align="flex-start">
                    <Icon
                      as={FaCheckCircle}
                      color="black"
                      opacity={0.7}
                      w={5}
                      h={5}
                      mt={1}
                    />
                    <Text
                      fontSize={textSize}
                      // color={useColorModeValue('#000000', '#000000')}
                    >
                      {text}
                    </Text>
                  </HStack>
                ))}
              </VStack>
            </MotionBox>
          </SimpleGrid>
        </Container>
      </Box>

      {/* Values Section */}
      <Box py={16} bg={useColorModeValue("white", "#000000")}>
        <Container maxW="container.xl" px={{ base: 6, md: 8 }}>
          <VStack textAlign="center" mb={12}>
            <Text
              fontSize="sm"
              fontWeight="semibold"
              color="black"
              letterSpacing="wide"
            >
              OUR FOUNDATION
            </Text>
            <Heading size="xl">Core Values That Guide Us</Heading>
            {/* <Divider w="80px" borderWidth="2px" borderColor="#87CEEB" /> */}
          </VStack>

          <SimpleGrid columns={{ base: 1, md: 3 }} spacing={8}>
            <ValueCard
              icon={FiShield}
              title="Integrity"
              description="We uphold the highest ethical standards in all our business dealings and relationships."
            />
            <ValueCard
              icon={FiGlobe}
              title="Sustainability"
              description="Committed to environmentally responsible practices in our manufacturing and operations."
            />
            <ValueCard
              icon={FiHeart}
              title="Passion"
              description="We bring enthusiasm and dedication to every project, no matter the size or scope."
            />
          </SimpleGrid>
        </Container>
      </Box>

      {/* Closing CTA */}
      <Box py={20}>
      {/* bgGradient="linear(to-r, #87CEEB, #800080)" */}
        <Container maxW="container.lg" textAlign="center">
          <MotionBox
            initial={{ opacity: 0 }}
            whileInView={{ opacity: 1 }}
            viewport={{ once: true }}
            transition={{ duration: 0.8 }}
          >
            <Heading size="xl" color="black" mb={6}>
              Ready to Transform Your Space?
            </Heading>
            <Text fontSize="xl" color="black.100" mb={8} maxW="2xl" mx="auto">
              Discover how ENSO's innovative glass solutions can elevate your
              home or business. Contact us today for a consultation.
            </Text>
            <MotionBox
              as="button"
              whileHover={{ scale: 1.05 }}
              whileTap={{ scale: 0.95 }}
              px={8}
              py={2}
              bg="black" 
              opacity={0.7}
              color={"white"}
              _hover={{ bg: "white", color: "black" }}
              onClick={() => navigate("/contact")}
              fontWeight="bold"
              borderRadius="md"
              boxShadow="lg"
              fontSize="lg"
            >
              Get in Touch
            </MotionBox>
          </MotionBox>
        </Container>
      </Box>
      <Footer />
    </Box>
  );
};

export default About;
